
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/add-circle","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#090A0A"}},[_c('path',{attrs:{"d":"M8 15.266a7.259 7.259 0 01-5.133-12.4 7.259 7.259 0 1110.265 10.266A7.215 7.215 0 018 15.266zM8 1.933A6.067 6.067 0 1014.067 8 6.074 6.074 0 008 1.933z"}}),_c('g',{attrs:{"data-name":"Group 687","opacity":".6"}},[_c('path',{attrs:{"data-name":"Vector","d":"M10.666 8.6H5.333a.6.6 0 01-.6-.6.6.6 0 01.6-.6h5.333a.6.6 0 01.6.6.6.6 0 01-.6.6z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8 11.266a.6.6 0 01-.6-.6V5.333a.6.6 0 01.6-.6.6.6 0 01.6.6v5.333a.6.6 0 01-.6.6z"}})])])])
          )
        }
      }
    